import React from "react";
import { X } from "lucide-react";

export default function JsonModal({ open, onClose, data }) {
    if (!open) return null;

    return (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-[600px] max-h-[80vh] overflow-auto p-5">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold">Chi tiết JSON</h2>
                    <button onClick={onClose} className="hover:text-red-500">
                        <X size={20} />
                    </button>
                </div>

                <pre className="bg-gray-100 p-4 rounded text-sm overflow-auto">
                    {JSON.stringify(data, null, 2)}
                </pre>
            </div>
        </div>
    );
}
